/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClientInquiry } from '../model';
/**
 * InquiryControllerApi - axios parameter creator
 * @export
 */
export const InquiryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all inquiries (Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InquiryControllerApi - functional programming interface
 * @export
 */
export const InquiryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InquiryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all inquiries (Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientInquiry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InquiryControllerApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InquiryControllerApi - factory interface
 * @export
 */
export const InquiryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InquiryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all inquiries (Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientInquiry>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InquiryControllerApi - object-oriented interface
 * @export
 * @class InquiryControllerApi
 * @extends {BaseAPI}
 */
export class InquiryControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get all inquiries (Admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InquiryControllerApi
     */
    public getAll(options?: RawAxiosRequestConfig) {
        return InquiryControllerApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
}

